import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarImage, AvatarFallback } from '@/ui/avatar';
import { getAvatarUrl } from '@/helpers/avatar';
import { cn } from '@/helpers/utils';

// Every profile avatar in the app (sidebar, admin, collaborators, workspace
// members, identity picker, deck ratings) needs the same three things: the
// DiceBear image, an initial-letter fallback, and the profile's own color as
// the avatar's background (bg-(--profile-color)) — this was getting
// re-implemented slightly differently at each call site, and easy to forget
// (workspace/[id]/page.js's member AvatarGroup had never gotten the color).
export const UserAvatar = t0 => {
  const $ = _c(28);
  let className;
  let imageClassName;
  let props;
  let size;
  let user;
  if ($[0] !== t0) {
    ({
      user,
      size,
      className,
      imageClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = imageClassName;
    $[3] = props;
    $[4] = size;
    $[5] = user;
  } else {
    className = $[1];
    imageClassName = $[2];
    props = $[3];
    size = $[4];
    user = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("bg-(--profile-color)", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = user?.color;
  let t3;
  if ($[8] !== t2) {
    t3 = {
      "--profile-color": t2
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = user?.avatar_seed;
  const t5 = user?.gender;
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = getAvatarUrl(t4, t5);
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = user?.name ?? "";
  let t8;
  if ($[13] !== imageClassName || $[14] !== t6 || $[15] !== t7) {
    t8 = <AvatarImage src={t6} alt={t7} className={imageClassName} />;
    $[13] = imageClassName;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== user?.name) {
    t9 = user?.name?.charAt(0)?.toUpperCase();
    $[17] = user?.name;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <AvatarFallback>{t9}</AvatarFallback>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== props || $[22] !== size || $[23] !== t1 || $[24] !== t10 || $[25] !== t3 || $[26] !== t8) {
    t11 = <Avatar size={size} className={t1} style={t3} {...props}>{t8}{t10}</Avatar>;
    $[21] = props;
    $[22] = size;
    $[23] = t1;
    $[24] = t10;
    $[25] = t3;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};